import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LeafletMouseEvent } from 'leaflet';
import { GeopositionMapComponent } from '../geoposition-map.component';
import { GeopositionMarkerData } from '../../../../modules/admin/tasks/tasks.types';

@Component({
    selector: 'single-geoposition-map',
    imports: [TranslocoModule],
    templateUrl: './single-geoposition-map.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './single-geoposition-map.component.scss'
})
export class SingleGeopositionMapComponent extends GeopositionMapComponent<GeopositionMarkerData> {
    @Input() canClickOnMap = false;
    @Input() 
    set geopositionSummaryList(value: GeopositionMarkerData[]) {
        super.geopositionSummaryList = value;
        this.geopositionSummaryListChanged.emit(value);
    }

    get geopositionSummaryList(): GeopositionMarkerData[] {
        return super.geopositionSummaryList;
    }

    @Output() geopositionSummaryListChanged = new EventEmitter<any[]>();

    protected initMap(): void {
        super.initMap();

        //Add click event handler
        if (this.canClickOnMap) {
            this.map.on('dblclick', (event: LeafletMouseEvent) => {
                const latLng = event.latlng;
                this.geopositionSummaryList = [{latitude: latLng.lat, longitude: latLng.lng }];
            });
        }
    }
}